import { inject, injectable } from "inversify";
import { Store } from "redux";
import { TYPES } from "../../dependencyInjection/Types";
import { ReportType } from "../../models/ReportType";
import { IExceptionHandler } from "../exceptionHandlers/IExceptionHandler";
import { IHttpClient } from "../HttpClient/IHttpClient";
import { IReportTypeService } from "./IReportTypeService";

@injectable()
export class ReportTypeService implements IReportTypeService {
    constructor(
        @inject(TYPES.Store) private store: Store,
        @inject(TYPES.HttpClient) private httpClient: IHttpClient,
        @inject(TYPES.IExceptionHandler) private exceptionHandler: IExceptionHandler
    ) {}

    getReportTypes(): Promise<void | ReportType[]> {
        return this.httpClient
            .get<ReportType[]>(`/report-type`)
            .catch((exception: any) =>
                this.exceptionHandler.handleError(
                    exception,
                    "We encountered an error while retrieving report types. Please try again. If the problem continues, contact your administrator"
                )
            );
    }
}
